import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";

const faqs = [
  ["Qual é o site oficial do DoramaFlix?", "O site oficial é doraflix.site. Outros endereços ou aplicativos usando o nome não têm relação com esta organização."],
  ["O DoramaFlix é por assinatura?", "Não. O modelo é de pagamento único por título ou pelo Passe Vitalício, sem renovação automática."],
  ["As novelinhas são dubladas ou legendadas?", "As duas coisas. A disponibilidade de áudio e legenda aparece em cada título."],
  ["Como falo com o suporte oficial?", "O suporte oficial funciona pelo Telegram e está disponível pelo botão de atendimento."],
];

export function AboutPage() {
  return (
    <article className="article-page page-container">
      <Seo title="Sobre o DoramaFlix Oficial — site oficial de doramas e novelas em português" description="Conheça o DoramaFlix Oficial, seu catálogo, modelo de pagamento único e suporte." path="/sobre" />
      <header className="article-header">
        <p className="eyebrow">DORAMAFLIX OFICIAL</p>
        <h1>Sobre o DoramaFlix Oficial</h1>
        <p>O DoramaFlix é uma plataforma brasileira voltada a doramas e novelinhas dubladas e legendadas em português. O endereço oficial é <a href="https://doraflix.site">doraflix.site</a>.</p>
      </header>

      <section className="warning-panel">
        <h2>Cuidado com sites falsos</h2>
        <p>Existem plataformas que usam o nome “DoramaFlix” sem relação com a organização. Não forneça dados bancários fora do checkout oficial e confirme sempre o domínio antes de entrar.</p>
      </section>

      <section>
        <h2>O que oferecemos</h2>
        <ul className="check-list">
          <li>Catálogo de doramas e novelas dubladas e legendadas em português.</li>
          <li>Categorias de romance, drama, ação, asiáticos, turcos e brasileiros.</li>
          <li>Prévia para conhecer o conteúdo antes de comprar.</li>
          <li>Player para celular, tablet e computador.</li>
          <li>Suporte oficial pelo Telegram.</li>
        </ul>
      </section>

      <section>
        <h2>Pagamento único, sem assinatura</h2>
        <p>Você pode desbloquear um título em pagamento único ou escolher o Passe Vitalício. Não há mensalidade ou renovação automática.</p>
      </section>

      <section>
        <h2>Suporte oficial</h2>
        <p>Dúvidas sobre pagamento, liberação de acesso ou reprodução são atendidas pelo suporte no Telegram.</p>
        <a className="secondary-button" href="https://t.me/suporte_doramaflix" target="_blank" rel="noreferrer">Abrir suporte no Telegram</a>
      </section>

      <section>
        <h2>Perguntas frequentes</h2>
        <div className="faq-list">
          {faqs.map(([question, answer]) => <details key={question}><summary>{question}</summary><p>{answer}</p></details>)}
        </div>
      </section>

      <section className="article-cta">
        <h2>Comece pelo catálogo oficial</h2>
        <p>Conheça os títulos disponíveis ou veja como funciona o Passe Vitalício.</p>
        <div className="button-row"><Link className="primary-button" to="/">Ver catálogo</Link><Link className="secondary-button" to="/vip">Conhecer o Passe Vitalício</Link></div>
      </section>
    </article>
  );
}
